import React from 'react';

function About() {
  return (
    <div className="container">

      {/* Heading */}
      <div className="row py-4 mt-4 border-top">
        <div className="col-12">
          <h1 className="text-center">People</h1>
        </div>
      </div>

      {/* Content */}
      <div
        className="row py-3 text-muted"
        style={{ lineHeight: "1.8" }}
      >

        {/* Image + Name */}
        <div className="col-12 col-md-6 text-center mb-4 mb-md-0 px-3">
          <img
            src="media/nithinKamath.jpg"
            alt="Nithin Kamath"
            className="img-fluid mb-3"
            style={{
              borderRadius: "50%",
              maxWidth: "200px"
            }}
          />

          <h4 className="mt-3">Nithin Kamath</h4>
          <h6>Founder and CEO</h6>
        </div>

        {/* Text Content */}
        <div className="col-12 col-md-6 px-3">
          <p>
            Nithin bootstrapped and founded Zerodha in 2010 to overcome
            the hurdles he faced during his decade-long stint as a trader.
            Today, Zerodha has changed the landscape of the Indian broking industry.
          </p>

          <p>
            He is a member of the SEBI Secondary Market Advisory Committee (SMAC)
            and the Market Data Advisory Committee (MDAC).
          </p>

          <p>
            Playing basketball is his zen. Connect on Homepage / TradingQnA / Twitter.
          </p>
        </div>

      </div>
    </div>
  );
}

export default About;